module.exports = __webpack_public_path__ + "img/beliefs_banner.cc577185.jpg";